/**
* @vue/shared v3.5.29
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const b = () => {
}, r = Object.prototype.hasOwnProperty, j = (t, e) => r.call(t, e), u = Array.isArray, y = (t) => n(t) === "[object Date]", o = (t) => typeof t == "function", h = (t) => typeof t == "string", s = (t) => t !== null && typeof t == "object", l = (t) => (s(t) || o(t)) && o(t.then) && o(t.catch), i = Object.prototype.toString, n = (t) => i.call(t), g = (t) => n(t) === "[object Object]", p = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return ((c) => e[c] || (e[c] = t(c)));
}, a = /-\w/g, f = p(
  (t) => t.replace(a, (e) => e.slice(1).toUpperCase())
);
export {
  b as NOOP,
  f as camelize,
  j as hasOwn,
  u as isArray,
  y as isDate,
  o as isFunction,
  s as isObject,
  g as isPlainObject,
  l as isPromise,
  h as isString,
  i as objectToString,
  n as toTypeString
};
